import React, {useState} from 'react'
import internet from '../assets/bg.svg'
import wave from '../assets/wave.jpg'
import avatar from '../assets/avatar.svg'
import {
  AiOutlineLock,
  AiOutlineUser
} from 'react-icons/ai'
import axios from 'axios';

const Register = () => {

// initialize form values
const [data, setData] = useState({
    email: "",
    password: "",
    cpassword: ""
})

// initialize error message
const [errorMessage, setErrorMessage] = useState('');

// set change form values
const handleChange = (e) =>{
    const newdata = { ...data }
    newdata[e.target.id] = e.target.value
    setData(newdata)
}
// sign up user
 const signUp = (e) =>{
      e.preventDefault();

      let formData = {
        email: data.email,
        password1: data.password
      };

      if(data.password !== data.cpassword){
        setErrorMessage("Passwords do not match")
      }
      else{
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: 'http://localhost:3005/new_user',
          headers: { 
            'Content-Type': 'application/json'
          },
          data : formData
        };
        
        axios.request(config)
        .then((response) => {
          setErrorMessage("")
          window.alert('User registration successful');
          window.location.replace('/login');
        })
        .catch((error) => {
          console.log(error?.response?.data?.error);
          setErrorMessage(error?.response?.data?.error)
        });
      }
    }

    const removeError = () => {
      setErrorMessage("")
    }
    
    return (
        <div>
            <img className="wave" src={wave} alt='' />
            <div className="auth-container">
                <div className="img">
                    <img src={internet} alt=''/>
                </div>
                <div className="login-content">
                    <form  onSubmit={signUp} className="regForm">
                        <img src={avatar} alt=''/>
                        <h2 className="title">New User</h2>
                        <div className="input-div one">
                        <div className="i">
                            <AiOutlineUser size={20} />
                        </div>
                        <div className="div">
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Email"
                              id="email"
                              onChange={handleChange}
                              onFocus={removeError}
                              required
                            />
                        </div>
                        </div>
                        <div className="input-div pass">
                          <div className="i"> 
                              <AiOutlineLock size={20}/>
                          </div>
                          <div className="div">
                              <input
                                type="password"
                                className="form-control"
                                placeholder="Password"
                                id="password"
                                onChange={handleChange}
                                onFocus={removeError}
                                required
                              />
                          </div>
                        </div>
                        <div className="input-div pass">
                          <div className="i"> 
                              <AiOutlineLock size={20}/>
                          </div>
                          <div className="div">
                              <input
                                type="password"
                                className="form-control"
                                placeholder="Confirm Password"
                                id="cpassword"
                                onChange={handleChange}
                                onFocus={removeError}
                                required
                              />
                          </div>
                        </div>
                        <input type="submit" className="Auth-btn" value="Create Account" />
                        {errorMessage && <div className="alert alert-danger Errorbox">{errorMessage}</div>}

                        <div className='exist-user'>
                          <a href="login">Already have an account?</a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Register